import Popup from "./Popup";

const RegolamentoClassifica = () => {
    const chiudi_regolamento = () => {
        document.querySelector("#regolamento").classList.add("chiuso");
    };

    return (
        <Popup id="regolamento" title="Regolamento Classifica Mobile" onClose={chiudi_regolamento}>
            <h3>Cos’è la Classifica Mobile</h3>
            <p>
                La Classifica Mobile Sporting è una classifica dinamica che permette
                ai giocatori di sfidarsi durante la stagione per salire di posizione.
            </p>

            <h3>Sfide</h3>
            <p>
                Ogni giocatore può sfidare esclusivamente avversari che si trovano
                sopra di lui di un massimo di <b>4 posizioni</b>.
            </p>
            <p>
                Una volta lanciata la sfida, lo sfidato deve dare disponibilità per
                giocare la partita entro <b>10 giorni</b>. In caso contrario,
                perderà automaticamente la sfida.
            </p>

            <h3>Esito della partita</h3>
            <p>
                Il vincitore della partita prende il posto del giocatore sconfitto
                oppure mantiene la propria posizione.
            </p>
            <p>
                Il giocatore sconfitto retrocede alla posizione del vincitore oppure
                mantiene la propria posizione.
            </p>

            <h3>Iscrizione</h3>
            <p>
                L’iscrizione è aperta a <b>soci e non soci</b>.
            </p>
            <p>
                Costo di iscrizione: <b>10€</b>.
            </p>

            <h3>Svolgimento dell’incontro</h3>
            <p>
                I giocatori devono prenotare autonomamente il campo per
                <b> un’ora di gioco</b> e portare le proprie palline.
            </p>
            <p>
                La partita si gioca con la formula di:
            </p>
            <ul>
                <li>Un solo set</li>
                <li>Punto secco sul 40 pari</li>
                <li>Tie-break classico</li>
            </ul>

            <h3>Categoria</h3>
            <p>
                La classifica è <b>mista</b>: uomini e donne possono sfidarsi tra loro.
            </p>
            <p>
                Età ammessa: da <b>13 a 112 anni</b>.
            </p>

            <h3>Finali</h3>
            <p>
                A inizio ottobre:
            </p>
            <ul>
                <li>I primi 4 uomini</li>
                <li>Le prime 4 donne</li>
            </ul>
            <p>
                Disputeranno le finali per decretare i vincitori delle categorie
                <b> maschile</b> e <b>femminile</b>.
            </p>

            <h3>Durata della race</h3>
            <ul>
                <li>Inizio: <b>10 aprile</b></li>
                <li>Termine iscrizioni: <b>30 agosto</b></li>
                <li>Chiusura classifica: <b>30 settembre</b></li>
            </ul>

            <h3>Nuovi iscritti</h3>
            <p>
                I nuovi iscritti vengono inseriti nella race in base alla
                <b> classifica FIT</b> o in base alla valutazione dell’organizzatore.
            </p>
            <h3>Per info</h3>
            <p>
                Marco torello al <b>+39 333 436 3911</b>
            </p>
        </Popup>
    );
};

export default RegolamentoClassifica;
